<template>
  <div id="holderListMobile">
    <div
      v-for="(group, number) in groups"
      :key="number"
      class="holdersType"
    >
      <el-row
        class="listHeader"
        type="flex"
        :gutter="2"
      >
        <el-col :span="18">
          <span
            v-if="group !== 'direct_report'"
            class="groupName"
          >
            {{ $t(`stakeholderGroup.${group}`) }}
          </span>
          <span
            v-else
            class="groupName"
          >
            {{ $t(`stakeholderGroup.${group}`) }}
          </span>
        </el-col>
        <el-col
          v-if="group !== 'deactivated'"
          class="addBtn"
          :span="6"
        >
          <!--<el-button @click.prevent="openModal(group, 'add')">
            + Add
          </el-button>-->
        </el-col>
      </el-row>
      <ul
        v-if="formattedStakeholders[group].length > 0 && !isIE"
        class="listBody"
      >
        <li
          v-for="(person, key) in formattedStakeholders[group]"
          :key="key"
        >
          <SwipeOut ref="swipe">
            <template>
              <div class="listInfo">
                <div
                  v-if="person && (person.first_name || person.last_name)"
                  class="userName"
                >
                  {{ `${person.first_name || ''} ${person.last_name || ''}` }}
                </div>
                <div class="userMail">
                  {{ person.email }}
                </div>
              </div>

              <div
                class="swipeArrow"
              >
                <img
                  src="@/assets/icon/swipeArrow.png"
                  alt="arrow"
                />
              </div>
            </template>

            <template
              v-if="group !== 'deactivated'"
              v-slot:right
            >
              <div
                class="swipeout-action black"
                @click="editStakeholder(person)"
              >
                <i class="el-icon-edit"></i>
                <div>
                  {{ $t('common.edit') }}
                </div>
              </div>
              <div
                v-if="isConfirmed"
                class="swipeout-action red"
                @click="removeStakeholder(person)"
              >
                <i class="el-icon-circle-close"></i>
                <div>
                  {{ $t('common.deactivate') }}
                </div>
              </div>
              <div
                v-else
                class="swipeout-action red"
                @click="removeStakeholder(person)"
              >
                <i class="el-icon-delete"></i>
                <div>
                  {{ $t('common.delete') }}
                </div>
              </div>
            </template>

            <template
              v-else
              v-slot:right
            >
              <div
                class="swipeout-action black"
                @click="reactivateStakeholder(person)"
              >
                <i class="el-icon-refresh-left"></i>
                <div>
                  {{ $t('common.activate') }}
                </div>
              </div>
            </template>
          </SwipeOut>
        </li>
      </ul>
      <div
        v-else
        class="noData"
      >
        <i>{{ $t('leader.coworker.noData') }}</i>
      </div>
    </div>

    <div
      class="buttonWrap"
    >
      <el-tooltip
        v-if="!isConfirmed"
        class="item"
        effect="dark"
        :content="$t('leader.coworker.publishTooltip')"
        placement="top"
        :disabled="!(isConfirmed || session < 3)"
      >
        <div>
          <el-button
            type="primary"
            round
            :disabled="isConfirmed || session < 3"
            :class="isConfirmed || session < 3 ? 'disabledButton' : ''"
            @click="$emit('confirmStakeholders')"
          >
            {{ $t('common.publish') }}
          </el-button>
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
// import { SwipeOut } from 'vue-swipe-actions';
import api from '@/api';

export default {
  components: {
    // SwipeOut,
    SwipeOut: () => import(/* webpackChunkName: "swipeAction" */ 'vue-swipe-actions').then((m) => m.SwipeOut), // async components loading to avoid IE loading it
  },

  props: {
    stakeholders: {
      type: Array,
      default: null,
    },

    isConfirmed: {
      type: Boolean,
      default: false,
    },

    session: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    groups: ['manager', 'peer', 'direct_report', 'other', 'deactivated'],
    editorDialog: false,
    modal: {
      type: 'add',
      group: 'manager',
    },
    publishModalVisible: false,
  }),

  computed: {
    ...mapState({
      role_type: (state) => state.user.user.role_type,
    }),

    editToModal: {
      get() {
        return this.edit;
      },
      set(newValue) {
        this.$emit('update:edit', newValue);
      },
    },

    isPublishModal: {
      get() {
        return this.isConfirmed;
      },
      set(newValue) {
        this.$emit('update:isConfirmed', newValue);
      },
    },

    formattedStakeholders() {
      const data = {
        manager: [],
        peer: [],
        direct_report: [],
        other: [],
        deactivated: [],
      };

      if (this.stakeholders.length < 1) return data;

      this.stakeholders.forEach((itemOne, i) => {
        if (!itemOne.is_active) {
          data.deactivated.push(itemOne);
        } else {
          this.groups.forEach((group) => {
            if (this.stakeholders[i].org_relationship === group) {
              data[group].push(this.stakeholders[i]);
            }
          });
        }
      });

      return data;
    },

    isIE() {
      return navigator.userAgent.indexOf('MSIE') !== -1
        || navigator.appVersion.indexOf('Trident/') > -1;
    },
  },

  methods: {
    ...mapActions('processStatus', [
      'fetchProcess',
    ]),

    closeAll() {
      this.$refs.swipe.forEach((item) => {
        item.closeActions();
      });
    },

    openModal(group, type) {
      this.modal.group = group;
      this.modal.type = type;
      this.editorDialog = true;
    },

    async removeStakeholder(stakeholder) {
      if (!this.isConfirmed) {
        this.$confirm(this.$t('leader.coworker.confirmRemove'), '', {
          confirmButtonText: this.$t('leader.coworker.yesDelete'),
          cancelButtonText: this.$t('common.goBack'),
          roundButton: true,
          customClass: 'stakeholderConfirmation',
        }).then(async () => {
          this.closeAll();
          try {
            if (this.role_type === 'coach') {
              await api.deleteLeaderCoworker(this.$route.params.id, stakeholder.uuid);
            } else {
              await api.deleteStakeholder(stakeholder.uuid);
            }
            this.$message.success(this.$t('leader.coworker.coworkerRemoved'));
            this.$emit('reload');
          } catch (err) {
            console.log(err);
            if (err.msg) {
              this.$message.error(err.msg);
            }
          }
        }).catch((err) => {});
      } else {
        this.$confirm(this.$t('leader.coworker.confirmDeactivate'), '', {
          confirmButtonText: this.$t('leader.coworker.yesDeactivate'),
          cancelButtonText: this.$t('common.goBack'),
          roundButton: true,
          customClass: 'stakeholderConfirmation',
        }).then(async () => {
          const local = stakeholder;
          local.is_active = false;
          await this.updateStakeholder(local);
        }).catch(() => {});
      }
    },

    reactivateStakeholder(stakeholder) {
      this.$confirm(this.$t('leader.coworker.confirmReactivate'), '', {
        confirmButtonText: this.$t('leader.coworker.yesReactivate'),
        cancelButtonText: this.$t('common.goBack'),
        roundButton: true,
        customClass: 'stakeholderConfirmation',
      }).then(async () => {
        const local = stakeholder;
        local.is_active = true;
        this.updateStakeholder(local);
      }).catch((err) => {});
    },

    async updateStakeholder(stakeholder) {
      try {
        this.closeAll();
        if (this.role_type === 'coach') {
          await api.updateLeaderCoworker(this.$route.params.id, stakeholder.uuid, {
            org_relationship: stakeholder.org_relationship,
            is_active: stakeholder.is_active,
          });
        } else {
          await api.updateStakeholder(stakeholder.uuid, {
            org_relationship: stakeholder.org_relationship,
            is_active: stakeholder.is_active,
          });
        }
        this.$message.success(this.$t('leader.coworker.infoSaved'));
        this.$emit('reload');
      } catch (err) {
        console.log(err);
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },

    editStakeholder(user) {
      const newOption = { flag: true, user };
      this.$emit('update:editDialog', newOption);
    },
  },
};
</script>

<style lang="scss" scoped>
  #holderListMobile {
    color: var(--themeFontColor);

    .holdersType {
      margin-bottom: 20px;

      .groupName {
        font-size: 16px;
        text-transform: capitalize;
      }

      .listHeader {
        padding: 5px 0;
        border-bottom: 2px solid #e5e5e5;
        align-items: center;
        font-weight: bold;
        min-height: 35px;

        .addBtn {
          text-align: right;

          .el-button {
            padding: 10px 0 10px 10px;
            max-width: 100%;
            background: transparent;
            border: none;
            color: white;
          }
        }
      }

      .listBody {
        list-style: none;
        margin: 0;
        padding: 0;

        li {
          height: 60px;
          border-bottom: 1px solid #c4c4c4;

          .listInfo {
            display: flex;
            height: 100%;
            padding: 0;
            flex-direction: column;
            justify-content: space-evenly;

            .userName {
              font-weight: bold;
              text-transform: capitalize;
            }
          }
        }

        .swipeout {
          width: 100%;
          height: 100%;

          .swipeArrow {
            display: flex;
            position: absolute;
            align-items: center;
            width: 15px;
            height: 100%;
            top: 0;
            right: 5px;

            img {
              width: 100%;
              height: 30%;
            }
          }

          .swipeout-content {
            padding-right: 10px;
          }

          .swipeout-action {
            padding-top: 10px;
            width: 81px;
            text-align: center;
            line-height: 1.5;
            font-size: 13px;

            i {
              font-size: 22px;
            }

            &.black {
              background: #343434;
            }

            &.red {
              background: #b00000;
            }
          }
        }
      }

      .noData {
        width: 100%;
        padding: 10px 0;
        color: #c4c4c4;
        font-size: 14px;
      }
    }

    .buttonWrap {
      margin-top: 10px;
      text-align: center;

      .disabledButton {
        background: #a1a1a1;
        border-color: #a1a1a1;
        opacity: 0.6;
      }
    }
  }

  .stakeholderConfirmation {
    // Necessary scss property
    $tablet: 899px;

    .el-message-box__btns {
      text-align: center;

      .el-message-box__content {
        padding: 25px 15px;
      }

      button {
        width: 150px !important;

        @media (max-width: $tablet) {
          width: 100% !important;
        }
      }
    }
  }
</style>
